import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Text } from '../../components/Text';
import { Button, Col, Row, Pagination, Modal, Form } from 'react-bootstrap';
import { Subtitle } from '../../components/SubTitle';
import Search from '../../components/Search';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { FillPen, FillPlus } from '../../components/Icons';
import { Title } from '../../components/Title';
import './style.css';
import AlertMessage from '../../components/Alert';
import DynamicTable from '../../components/DynamicTable';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';

export function TabelasDinamicas() {
    const [isLoading, setIsLoading] = useState(false);
    const [observacao, setObservacao] = useState('');
    const [nome, setNome] = useState('');
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [employees, setEmployees] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [employeesPerPage, setEmployeesPerPage] = useState(20);
    const [employeesPerPageOptions] = useState([5, 10, 15, 20, 50, 100]);
    const [searchQuery, setSearchQuery] = useState('');
    const [dynamicTables, setDynamicTables] = useState([]);
    const [selectedTableType, setSelectedTableType] = useState('');
    const [tipo, setTipo] = useState(null);
    const [headerColor, setHeaderColor] = useState('#ccc');
    const [cor, setCor] = useState('#000000');
    const [show, setShow] = useState(false);
    const [showRegisterModal, setShowRegisterModal] = useState(false);
    const [idSelected, setIdSelected] = useState('');
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [isEditing, setIsEditing] = useState(false);
    const [selectedTable, setSelectedTable] = useState(0);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedCheckboxTables, setSelectedCheckBoxTables] = useState<any>([]);

    const showModal = async (id: any, tipo: string, cor: string) => {
        setIdSelected(id);
        setSelectedTableType(tipo);
        setShow(true);
        setHeaderColor(cor);
    }

    // Calcula o índice do primeiro e do último funcionário na página atual
    const indexOfLastEmployee = currentPage * employeesPerPage;
    const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;

    const currentEmployees = employees.slice(indexOfFirstEmployee, indexOfLastEmployee);

    const filteredEmployees = employees.filter((employee: any) => {
        return (
            employee.nome.toLowerCase().includes(searchQuery.toLowerCase()) ||
            employee.id.toString().includes(searchQuery)
        );
    });

    const handleClose = () => setShow(false);

    const handleCloseRegisterModal = () => {
        setIsEditing(false);
        setTipo(null);
        setNome('');
        setCor('');
        setObservacao('');
        setShowRegisterModal(false);
    }

    const handleEmployeesPerPageChange = (value: any) => {
        setEmployeesPerPage(Number(value));
        setCurrentPage(1); // Volta para a primeira página ao mudar a quantidade por página
    };

    useEffect(() => {
        fetchDynamicTables();
    }, []);

    const formatDate = (dateString: any) => {
        const date = new Date(dateString);
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()} às ${(date.getHours()).toString().padStart(2, '0')}h${date.getMinutes().toString().padStart(2, '0')}`;
        return formattedDate;
    };


    const fetchDynamicTables = async () => {
        try {
            const tables = await api.get('listar-tabelas-dinamicas');
            const responseData = tables.data;

            setDynamicTables(responseData);
        } catch (error) {
            console.error("Error updating employee status:", error);
        }
    };

    // Atualizar a consulta de pesquisa
    const handleSearchChange = (value: string) => {
        setSearchQuery(value);
        setCurrentPage(1);
    };

    /*paginação*/
    const paginationItems = () => {
        let items = [];
        const totalPaginas = Math.ceil(filteredEmployees.length / employeesPerPage); // Use filteredEmployees para calcular o total de páginas

        // Primeira página
        if (currentPage > 2) {
            items.push(
                <Pagination.Item
                    key="first"
                    onClick={() => setCurrentPage(1)}
                >
                    1
                </Pagination.Item>
            );
        }

        // Reticências antes da página atual, se necessário
        if (currentPage > 3) {
            items.push(<Pagination.Ellipsis key="startEllipsis" disabled />);
        }

        // Página anterior à atual, se aplicável
        if (currentPage > 1) {
            items.push(
                <Pagination.Item
                    key={currentPage - 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    {currentPage - 1}
                </Pagination.Item>
            );
        }

        // Página atual
        items.push(
            <Pagination.Item
                key={currentPage}
                active
            >
                {currentPage}
            </Pagination.Item>
        );

        // Página seguinte à atual, se aplicável
        if (currentPage < totalPaginas) {
            items.push(
                <Pagination.Item
                    key={currentPage + 1}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    {currentPage + 1}
                </Pagination.Item>
            );
        }

        // Reticências depois da página atual, se necessário
        if (currentPage < totalPaginas - 2) {
            items.push(<Pagination.Ellipsis key="endEllipsis" disabled />);
        }

        // Última página
        if (currentPage < totalPaginas - 1) {
            items.push(
                <Pagination.Item
                    key="last"
                    onClick={() => setCurrentPage(totalPaginas)}
                >
                    {totalPaginas}
                </Pagination.Item>
            );
        }

        return items;
    };

    const handleSubmit = async () => {
        if (!tipo) {
            setAlert({ message: 'Você deve selecionar uma versão para copiar.', variant: 'danger', show: true });
            return;
        }
        setIsEditing(false);
        try {
            const payload = {
                nome,
                tipo,
                cor,
                observacoes: observacao,
                ativado: 0,
                id: selectedTable
            };

            if (!isEditing) {
                const response = await api.post('inserir-tabela-dinamica', payload);
                if (response.status === 200) {
                    setShowRegisterModal(false);
                    setNome('');
                    setTipo(null);
                    setCor('');
                    setObservacao('');
                    setAlert({ message: 'Tabela inserida com sucesso!', variant: 'success', show: true });
                    fetchDynamicTables();
                }
            } else {
                const response = await api.post('atualizar-tabela-dinamica', payload);
                if (response.status === 200) {
                    setShowRegisterModal(false);
                    setIsEditing(false);
                    setNome('');
                    setTipo(null);
                    setCor('');
                    setObservacao('');
                    setAlert({ message: 'Tabela atualizada com sucesso!', variant: 'success', show: true });
                    fetchDynamicTables();
                }
            }
        } catch (error) {
            console.log(error);
        }
    };


    const handleSelectChange = (value: any) => {
        const selectedOption: any = dynamicTables.find((table: any) => table.id === parseInt(value));
        setTipo(selectedOption ? selectedOption.tipo : null);
    };

    const handleEdit = async (id: number) => {
        setIsEditing(true);
        try {
            const response = await api.post(`buscar-tabela-dinamica/${id}`);
            const responseData = response.data[0];

            setTipo(responseData.tipo);
            setNome(responseData.nome);
            setObservacao(responseData.observacoes);
            setCor(responseData.cor);
            setSelectedTable(id);
            setShowRegisterModal(true);

        } catch (error) {
            console.log(error)
        }
    }

    const handleActivate = async (id: number) => {
        try {
            const response = await api.post(`atualizar-padrao/${id}`);

            if (response.status == 200) {
                setAlert({ message: 'Padrão atualizado com sucesso!', variant: 'success', show: true });
                fetchDynamicTables();
            }

        } catch (error) {
            console.log(error)
        }
    }

    const handleSelectAll = () => {
        setSelectAll(!selectAll);
        setSelectedCheckBoxTables(selectAll ? [] : dynamicTables.map((table: any) => table.id));
    };

    const handleSelectTables = (id: string) => {
        const tabelas = dynamicTables.find((table: any) => table.id === id);
        if (tabelas) {
            setSelectedCheckBoxTables((prevSelected: any) =>
                prevSelected.includes(id) ? prevSelected.filter((tableId: any) => tableId !== id) : [...prevSelected, id]
            );

        }
    };

    const handleDeleteSelectedTables = async () => {
        if (selectedCheckboxTables.includes(1) || selectedCheckboxTables.includes(2)) {
            setAlert({ message: 'Os itens padronizados não podem ser excluídos.', variant: 'danger', show: true });
            return;
        }
        try {
            const response = await api.post('excluir-tabelas-selecionadas', selectedCheckboxTables);
            if (response.status == 200) {
                setAlert({ message: 'Tabelas excluídas com sucesso!', variant: 'success', show: true });
                setSelectedCheckBoxTables([]);
                fetchDynamicTables();
            }
        } catch (error) {
            console.log(error);
        }
    }




    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmação de exclusão</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Você tem certeza que deseja excluir este item?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancelar
                        </Button>
                        <Button variant="primary">
                            Confirmar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <CardContent>
                    <Row className='my-4'>
                        <Title text="Tabelas Dinâmicas" />
                        <Col md={8} className='newbutton'>
                            <Button className='btn-main' onClick={() => setShowRegisterModal(true)}><FillPlus /> Nova Tabela</Button>
                        </Col>
                        <Col md={4}>
                            <Search placeHolder="Procure pelo nome" onChange={handleSearchChange} />
                        </Col>
                    </Row>
                    <Row className='mb-4'>
                        <Col sm={2} className='my-2 d-flex justify-content-end' style={{ width: '200px' }}>
                            <Select id='employeesPerPageSelect' onSelect={handleEmployeesPerPageChange}>
                                {employeesPerPageOptions.map((option) => (
                                    <Options
                                        key={option}
                                        value={option}
                                        name={`${option} por página`}
                                        selected={option === employeesPerPage}
                                    />
                                ))}
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div>
                                <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', maxHeight: '250px', overflowY: 'auto', marginTop: '30px' }}>
                                    <table className="table-row-tabelas" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead style={{ backgroundColor: '#007bff', color: 'white' }}>
                                            <tr>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>
                                                    <input
                                                        type="checkbox"
                                                        onChange={handleSelectAll}
                                                        checked={selectAll}
                                                    />
                                                </th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Código</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Nome</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Atualização</th>
                                                <th style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dynamicTables.map((table: any, index) => (
                                                <tr key={index}>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedCheckboxTables.includes(table.id)}
                                                            onChange={() => handleSelectTables(table.id)}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{table.id}</td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{table.nome}</td>
                                                    <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                        {formatDate(table.updated_at ? table.updated_at : table.created_at)}
                                                    </td>
                                                    <td style={{ borderTop: '1px solid lightgray', padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                        <Button onClick={() => showModal(table.id, table.tipo, table.cor)} style={{ border: 'none' }}>
                                                            <RemoveRedEyeIcon />
                                                        </Button>
                                                        <Button style={{ backgroundColor: '#DAB601', border: 'none' }} onClick={() => handleEdit(table.id)}>Editar</Button>
                                                        {table.ativado === 1 ? (
                                                            <Button style={{ backgroundColor: 'transparent', border: '1px solid', borderColor: 'green', color: 'green' }}>
                                                                Ativado
                                                            </Button>
                                                        ) : (
                                                            <Button style={{ backgroundColor: 'transparent', border: '1px solid', borderColor: 'gray', color: 'gray' }} onClick={() => handleActivate(table.id)}>
                                                                Ativar
                                                            </Button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                            {selectedCheckboxTables.length > 0 && (
                                <div style={{ marginTop: '20px', display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                                    <Button style={{ backgroundColor: 'red', color: 'white', border: 'none' }} onClick={handleDeleteSelectedTables}>
                                        Excluir Selecionados
                                    </Button>
                                </div>
                            )}
                        </Col>
                        <Col className='d-flex justify-content-center mt-4'>
                            <div className="pagination">
                                <Pagination>
                                    {paginationItems()}
                                </Pagination>
                            </div>
                        </Col>
                    </Row>
                </CardContent>
                <Modal show={show} onHide={handleClose} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>Visualizar Tabela</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <DynamicTable
                            type={selectedTableType}
                            headerColor={headerColor}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={showRegisterModal} onHide={handleCloseRegisterModal} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>Cadastrar Nova Tabela</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col xs={12} md={6} xl={6}>
                                    <FormGroup style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                        <Label title='Copiar Versão' htmlFor="selectResponsavel" />
                                        <Select id="selectResponsavel" onSelect={handleSelectChange}>
                                            {dynamicTables.map((table: any) => (
                                                <Options
                                                    key={table.id}
                                                    value={table.id}
                                                    name={table.nome}
                                                />
                                            ))}
                                        </Select>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={6} xl={6}>
                                    <FormGroup>
                                        <Label title='Nome' htmlFor="nome" />
                                        <input
                                            type="text"
                                            id="nome"
                                            placeholder="Digite o Nome"
                                            value={nome}
                                            onChange={(e) => setNome(e.target.value)}
                                            style={{ width: '100%', marginBottom: '10px' }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <FormGroup>
                                        <Label title='Cor das Colunas' htmlFor="cor" />
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <input
                                                className='corColuna'
                                                type="color"
                                                id="cor"
                                                value={cor}
                                                onChange={(e) => setCor(e.target.value)}
                                                style={{ marginRight: '10px', marginBottom: '10px' }}
                                            />
                                            <span>{cor}</span>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <FormGroup>
                                        <Label title='Observações' htmlFor="descricao" />
                                        <textarea
                                            id="observacao"
                                            placeholder="Digite as observações"
                                            value={observacao}
                                            onChange={(e) => setObservacao(e.target.value)}
                                            style={{ width: '100%', minHeight: '100px' }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={handleSubmit}>
                            Salvar
                        </Button>
                        <Button variant="secondary" onClick={handleCloseRegisterModal}>
                            Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div >
    );
}